<template>
    <section>
        <fixed-header title="Commission Rates" hideNewOfferBtn />
        <div class="card">
            <div class="card-body">
                <b-row>
                    <b-col>
                        <b-button variant="primary" @click="openNewForm(true)" size="sm" class="mb-1">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                            Add Sales Commission Rate
                        </b-button>
                        <grid-component
                            :itemData="salesList"
                            :fields="fields"
                            :handleRowClick="onRowClick"
                         />
                    </b-col>
                    <b-col>
                        <b-button variant="primary" @click="openNewForm(false)" size="sm" class="mb-1">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                            Add Purchase Commission Rate
                        </b-button>
                        <grid-component
                            :itemData="purchasesList"
                            :fields="fields"
                            :handleRowClick="onRowClick"
                         />
                    </b-col>
                </b-row>
                <b-modal size="sm" ok-title="Save" id="commission-rate-form" title="Commission Rate" @ok="onSaveItem">
                    <b-row>
                        <b-col>
                            <b-form-group label="Commission Amount ($)">
                                <b-form-input v-model="itemObj.amount" placeholder="Amount"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Commission Rate (%)">
                                <b-form-input v-model="itemObj.rate" placeholder="Rate"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-modal>
            </div>
        </div>
    </section>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import { GRID_ID, DATE_FORMAT } from '@/shared/constants';
import GridComponent from '@/shared/components/GridComponent';

export default {
    components: {
        FixedHeader, 
        GridComponent
    },
    data() {
        return {
            fields: [
                {
                    key: 'amount',
                    field: 'amount',
                    title: 'Amount',
                    label: 'Amount',
                    cell: 'formatCurrencyConverted'
                },
                {
                    key: 'rate',
                    field: 'rate',
                    title: 'Rate',
                    label: 'Rate',
                    cell: 'formatPercentage'
                },
                {
                    field: 'deletecommands',
                    title: ' ',
                    cell: 'deletecommands',
                    headerCell: 'commandsHeader',
                    sortable: true,
                    hidden: false,
                    locked: true,
                    width: 30,
                },
            ],
            itemObj: {}    
        }
        
    },
    computed: {
        ...mapGetters('commissionRate', ['salesList', 'purchasesList'])
    },
    methods: {
        ...mapActions('commissionRate', [
            'getAll',
            'createCommissionRate',
            'updateCommissionRate',
            'deleteCommissionRate'
        ]),
        getData() {
            this.getAll({});
        },
        openNewForm(isSales) {
            this.itemObj = { 
                id: 0,
                isSalesCommission: isSales
            }
            this.$bvModal.show('commission-rate-form');
        },
        onRowClick({dataItem}) {
            this.itemObj = { ...dataItem };
            this.$bvModal.show('commission-rate-form');
        },
        async onSaveItem() {
            if (this.itemObj.id) {
                await this.updateCommissionRate({
                    id: this.itemObj.id, 
                    commissionRate: this.itemObj
                });
            } else {    
                await this.createCommissionRate(this.itemObj);
            }

            this.getData();
        },
        async onDelete(item) {
            const response = await this.openConfirmBox({ message: `Are you sure you want to remove this commission rate?` });
            if (response) {
                this.deleteCommissionRate(item.id).then((res) => {
                    if (res.status == 200) {
                        if (item.isSalesCommission) {
                            let i = this.salesList.findIndex(x => x.id == item.id);
                            if (i > -1) {
                                this.salesList.splice(i,1);
                            } 
                        } else {
                            let i = this.purchasesList.findIndex(x => x.id == item.id);
                            if (i > -1) {
                                this.purchasesList.splice(i,1);
                            }
                        }                       

                        this.$snotify.success('Successfully deleted commission');
                    }
                })     
            }
        }
    },
    mounted() {
        this.getData();
    }
}
</script>